import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvironmentService } from '../environment.service';

@Injectable()
export class TealiumTagService {
  constructor(
    // tslint:disable-next-line: variable-name
    @Inject(DOCUMENT) private _document,
    private environment: EnvironmentService
  ) { }

  private tealiumConfig = this.environment.getTealiumConfig();
  private optimizelyUrl = this.environment.getOptimizelyUrl();

  public setConfig(renderer2: Renderer2): void {
    const s = renderer2.createElement('script');
    s.type = `text/javascript`;
    s.text = `window.utag_cfg_ovrd = window.utag_cfg_ovrd || {}; window.utag_cfg_ovrd.noview = true;`;

    renderer2.appendChild(this._document.head, s);
  }

  public setTag(renderer2: Renderer2): void {
    const s = renderer2.createElement('script');
    s.type = `text/javascript`;
    s.src = `//tags.tiqcdn.com/utag/${this.tealiumConfig.ACCOUNT}/${this.tealiumConfig.PROFILE}/${this.tealiumConfig.ENVIRONMENT}/utag.js`;

    renderer2.appendChild(this._document.head, s);
  }

  public setOptimizely(renderer2: Renderer2): void {
    const s = renderer2.createElement('script');
    s.type = `text/javascript`;
    s.src = `${this.optimizelyUrl}`;

    renderer2.appendChild(this._document.head, s);
  }
}

// future implementation we want to use recommended by Tealium
@Injectable()
export class TealiumUtagService {
  // tslint:disable-next-line: variable-name
  script_src = '';

  // Typically set 'noview' flag (no first page automatic view event) to true for Single Page Apps (SPAs)
  constructor() {
    (window as any).utag_cfg_ovrd = (window as any).utag_cfg_ovrd || {};
    (window as any).utag_cfg_ovrd.noview = true;
    (window as any).utag_data = {};
  }

  // Generic script loader with callback
  // tslint:disable-next-line: ban-types
  getScript(src: string, callback: Function) {
    const d = document;
    // tslint:disable-next-line: only-arrow-functions
    const o = { callback: callback || function() { } };
    let s;
    let t;

    if (typeof src === 'undefined') {
      return;
    }

    s = d.createElement('script'); s.language = 'javascript'; s.type = 'text/javascript'; s.async = 1; s.charset = 'utf-8'; s.src = src;
    if (typeof o.callback === 'function') {
      if (d.addEventListener) {
        s.addEventListener('load', () => { o.callback(); }, false);
      } else {
        // old IE support
        s.onreadystatechange = function() { if (this.readyState === 'complete' || this.readyState === 'loaded') { this.onreadystatechange = null; o.callback(); } };
      }
    }
    t = d.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
  }

  // Config settings used to build the path to the utag.js file
  setConfig(config: { account: string, profile: string, environment: string }) {
    if (config.account !== undefined && config.profile !== undefined && config.environment !== undefined) {
      this.script_src = `https://tags.tiqcdn.com/utag/'${config.account}/${config.profile}/${config.environment}/utag.js`;
    }
  }

  // Data layer is optional set of key/value pairs
  // tslint:disable-next-line: variable-name
  track(tealium_event: string, data?: any) {
    if (this.script_src === '') {
      return;
    }
    if ((window as any).utag === undefined) {
      this.getScript(this.script_src, () => {
        (window as any).utag.track(tealium_event, data);
      });
    } else {
      (window as any).utag.track(tealium_event, data);
    }
  }

  view(data?: any) {
    this.track('view', data);
  }

  link(data?: any) {
    this.track('link', data);
  }
}

